export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/ac478f259eebce517c6cc06e4306b00d.svg";